export const ordersReducer = (state = {loading: true, resultorder: null, orders: null, order: null, productWrong: null, resultPayment: null, formParams: null, paymentStatus: null, total: 0} , action) => {
    switch (action.type) {
        case 'ORDER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                orders: action.payload.orders,
                total: action.payload.total
            }
        case 'ORDER_ADD_SOCKET_SUCCESS':
            return {...state, orders: [...state.orders, action.payload]}
        case 'ORDER_PRINTED_SOCKET_SUCCESS':
            return {
                ...state,
                orders: state.orders?.map(order => {

                    if(order._id === action.payload){
                        order.isPrinted = true
                    }
                    return order
                })
            }
        case 'ORDER_PAID_SOCKET_SUCCESS':
            console.log('Pyaload: ', action.payload)
            return {
                ...state,
                orders: state.orders.map(order => 
                    order._id === action.payload ? {...order, isPaid: true} : order
                )
            }
        case 'ORDER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                order: action.payload
            }
        case 'ORDER_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultorder: action.payload.message,
                productWrong: action.payload.product
            }
        case 'ORDER_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultorder: action.payload
            }
        case 'ORDER_REMOVE_SUCCESS':
            return {
                ...state,
                loading:false,
                orders: state.orders.filter(order => order._id !== action.payload.id),
                resultorder: action.payload.message
            }
        case 'ORDER_EDITSTATEKITCHEN_SUCCESS':
            return {
                ...state,
                loading:false,
                resultorder: action.payload.message,
                order: {
                    ...state.order,
                    isDelivered: action.payload.newstateorder
                }
            }
        case 'ORDER_EDITSTATEADMIN_SUCCESS':
            return {
                ...state,
                loading:false,
                resultorder: action.payload.message,
                orders: state.orders?.map(order => {
                    if(order._id === action.payload.stateorder){
                        return {
                            ...order,
                            isDelivered: action.payload.newstateorder
                        }
                    }else{
                        return order
                    }
                })
            }
        case 'ORDER_EDITSTATE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultorder: action.payload.message,
                orders: state.orders.filter(order => order._id !== action.payload.stateorder)
            }
        case 'ORDER_RESET_RESULT':
            return {...state,
                resultorder: null
            }
        case 'ORDER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ORDER_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'ORDER_PAY_SUCCESS':
            return {
                ...state,
                loading: false,
                resultPayment: 'success'
            }
        case 'ORDER_PAY_RESET':
            return {
                ...state,
                resultPayment: null
            }
        case 'ORDER_GET_PAYMENT_FORM_SUCCESS':
            return {
                ...state,
                loading: false,
                formParams: action.payload
            }
        case 'ORDER_GET_PAYMENT_FORM_RESET':
            return {
                ...state,
                formParams: null
            }
        case 'ORDER_GET_PAYMENT_STATUS_SUCCESS':
            return {
                ...state,
                loading: false,
                paymentStatus: action.payload
            }
        case 'ORDER_GET_PAYMENT_STATUS_RESET':
            return {
                ...state,
                paymentStatus: null
            }
        default:
            return state
    }
}